export const LocalStorageConstants = {
  OKTA_TOKEN: "okta-token-storage",
  ORIGINAL_URI: "blue-original-uri",
  LAST_CACHE_TIME: "last-cache-time",
  MILBHUB_INTEGRATION_AUTH: "best-blue-milbhub-integration",
};
